/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Is_VisibleInputs */

const en_reference_field_is_visible = /** @type {(inputs: Reference_Field_Is_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offered in the forms`)
};

/**
* | output |
* | --- |
* | "Offered in the forms" |
*
* @param {Reference_Field_Is_VisibleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_is_visible = /** @type {((inputs?: Reference_Field_Is_VisibleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Is_VisibleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_is_visible(inputs)
});